// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.check-wrapper{padding:0 20%}.check-wrapper .pdf-reader .pdf-container{height:60vh}`, "",{"version":3,"sources":["webpack://./src/components/documents/Check.scss"],"names":[],"mappings":"AAAA,eACI,aAAA,CACA,0CACI,WAAA","sourcesContent":[".check-wrapper {\n    padding: 0 20%;\n    .pdf-reader .pdf-container{\n        height: 60vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
